import React from 'react';
import PropTypes from 'prop-types';

import FreeShip from '../FreeShip/FreeShip';
import CartGiftMessage from '../CartGiftMessage/CartGiftMessage';
import PlusReleaseDate from '../PlusReleaseDate/PlusReleaseDate';
import CartDiscount from '../CartDiscount/CartDiscount';
import KlarnaPlacement from '../KlarnaPlacement/KlarnaPlacement';
import { StyledDiv, StyledFlexDiv, StyledRightFlex, StyledTitle, StyledSubtotal, StyledSubtotalAmount, StyledStrikeThrough, StyledInfo } from './CartDrawerHeaderStyles';

import { getCurrency } from '../../Utils/PriceUtils';

var _ref = React.createElement(
  'p',
  null,
  'Subtotal:'
);

var _ref2 = React.createElement(
  StyledInfo,
  null,
  'Shipping + Taxes Calculated at Checkout'
);

var CartDrawerHeader = function CartDrawerHeader(props) {
  var showFullSubtotal = props.checkout.subtotalPriceV2.amount != props.checkout.lineItemsSubtotalPrice.amount;

  var checkoutSubtotal = getCurrency(props.checkout.subtotalPriceV2.currencyCode, props.checkout.subtotalPriceV2.amount);
  var lineItemsSubtotal = getCurrency(props.checkout.lineItemsSubtotalPrice.currencyCode, props.checkout.lineItemsSubtotalPrice.amount);

  var klarnaPrice = parseFloat(lineItemsSubtotal.replace('$', ''));

  return React.createElement(
    StyledDiv,
    null,
    React.createElement(
      StyledFlexDiv,
      null,
      React.createElement(
        'div',
        null,
        React.createElement(
          StyledTitle,
          null,
          'Your Cart',
          ' ',
          React.createElement(
            'span',
            null,
            '(',
            props.cartQuantity,
            ')'
          )
        ),
        React.createElement(FreeShip, {
          subtotalPrice: props.checkout.subtotalPriceV2.amount,
          discountThresholdAmount: props.discountThresholdAmount
        })
      ),
      React.createElement(
        StyledRightFlex,
        null,
        React.createElement(
          StyledSubtotal,
          null,
          _ref,
          React.createElement(
            StyledSubtotalAmount,
            null,
            React.createElement(
              'p',
              null,
              checkoutSubtotal
            ),
            showFullSubtotal && React.createElement(
              StyledStrikeThrough,
              null,
              lineItemsSubtotal
            )
          )
        ),
        klarnaPrice > 35 && React.createElement(KlarnaPlacement, { price: klarnaPrice }),
        _ref2,
        React.createElement(CartGiftMessage, {
          addCheckoutNote: props.addCheckoutNote,
          checkoutNote: props.checkoutNote
        }),
        window.Dormify.shipLaterEnabled && React.createElement(PlusReleaseDate, {
          addPlusReleaseDate: props.addPlusReleaseDate,
          checkoutCustomAttributes: props.checkoutCustomAttributes,
          noVendorItems: props.noVendorItems
        })
      )
    ),
    React.createElement(CartDiscount, {
      addDiscountCode: props.addDiscountCode,
      removeDiscountCode: props.removeDiscountCode,
      discountCode: props.checkoutDiscountCodes && props.checkoutDiscountCodes.edges[0],
      autoDiscountPromo: props.autoDiscountPromo,
      autoDiscountCode: props.autoDiscountCode,
      autoDiscountCodeEndDate: props.autoDiscountCodeEndDate,
      formSubmitted: props.formSubmitted,
      formDiscountCode: props.formDiscountCode
    })
  );
};

CartDrawerHeader.propTypes = {
  checkout: PropTypes.object.isRequired,
  webUrl: PropTypes.string,
  cartQuantity: PropTypes.number,
  handleCartClose: PropTypes.func,
  addCheckoutNote: PropTypes.func.isRequired,
  checkoutNote: PropTypes.string,
  addPlusReleaseDate: PropTypes.func.isRequired,
  checkoutCustomAttributes: PropTypes.array,
  noVendorItems: PropTypes.bool,
  addDiscountCode: PropTypes.func.isRequired,
  removeDiscountCode: PropTypes.func.isRequired,
  checkoutDiscountCodes: PropTypes.object,
  autoDiscountPromo: PropTypes.bool,
  autoDiscountCode: PropTypes.string,
  autoDiscountCodeEndDate: PropTypes.string,
  formSubmitted: PropTypes.bool,
  formDiscountCode: PropTypes.string,
  discountThresholdAmount: PropTypes.string
};

export default CartDrawerHeader;